import { ProductCollectionSortKeys } from 'shopify/api'

export const getSortVariables = (initialSort: string) => {
  let sortVariable: ProductCollectionSortKeys | null
  let reverse: boolean | null = false
  switch (initialSort) {
    case 'relevant':
      sortVariable = ProductCollectionSortKeys.Relevance
      break
    case 'new-product':
      sortVariable = ProductCollectionSortKeys.Created
      break
    case 'most-selling':
      sortVariable = ProductCollectionSortKeys.BestSelling
      break
    case 'lowest-price':
      sortVariable = ProductCollectionSortKeys.Price
      break
    case 'highest-price':
      sortVariable = ProductCollectionSortKeys.Price
      reverse = true
      break
    default:
      sortVariable = ProductCollectionSortKeys.Relevance
  }
  return { sortVariable, reverse }
}
